import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import { upgradeShopifySubscription } from '../../services/shopifySubscription';
import { checkoutSession, getPlans } from '../../services/stripe';
import getAmount from '../../Util/getAmount';
import { wholeNumber } from '../../Util/roundOff';


const PricingPlans = () => {

    const {setPricingPopupOpen,
        isFetching, 
        planDetails,
        setChosenPlan,
        setIsVerifyPopupOpen,
        setChatVisibility,
        selectedWebsite,
        isShopify,
        setIsLoadings
    } = useAppContext();


    const [freePlanSubscribers, setFreePlansSubscribers ] = useState(200);
    const [plans, setPlans] = useState([]);

    const [ planType, setPlanType ] = useState('subscriber-based');
    const [ planDuration, setPlanDuration ] = useState('month');
    const [ subscriberCount, setSubscribersCount ] = useState(0);
    const [ activePlanTypes, setActivePlanTypes ] = useState([]);
    const [ selectedSubscriber, setSelectedSubscriber ] = useState(null);
    const [ customPlan, setCustomPlan] = useState(null);


    const rounded = num => {
        if (num > 1000000000) {
          return Math.round(num / 100000000) / 10 + 'Bn';
        } else if (num > 1000000) {
          return Math.round(num / 100000) / 10 + 'M';
        } else {
          return Math.round(num / 100) / 10 + 'K';
        }
      };


    useQuery('fetchPricingPlans', getPlans, {
        onSuccess: (plans) => {
            setPlans(plans);
            const {subscription_thresholds} = plans.find(({amount}) => amount === '0');
            setFreePlansSubscribers(subscription_thresholds);
            setPlanSliderValues(plans, planDuration, planType);

            const customPlan = plans.find(({is_custom}) => is_custom);
            if(customPlan) {
                setCustomPlan(customPlan);
            }

        }
    });

    const setPlanSliderValues = (plans, planDuration, planType) => {
        const plansByType = plans.filter(({type, amount, recurring}) => {  
            return type === planType &&  amount !== '0' && recurring.interval === planDuration
        });
        plansByType.sort((planA, planB) => planA.sequence_id - planB.sequence_id);
        setSelectedSubscriber(plansByType[0]);
        setSubscribersCount(0);
        setActivePlanTypes(plansByType);
    }

    const onChangePlan = () => {
        if(planType === 'subscriber-based') {
            setPlanType('impression-based');
            setPlanSliderValues(plans, planDuration, 'impression-based');
        } else if(planType === 'impression-based') {
            setPlanType('subscriber-based');
            setPlanSliderValues(plans, planDuration, 'subscriber-based');
        }
        
    }

    const onChangeSlider = (value) => {
        const selectedSubscriber = value === 0 ? activePlanTypes[1] : activePlanTypes[(value/2)];
        setSubscribersCount(value);
        setSelectedSubscriber(selectedSubscriber);
    }

    const onChangeDuration= (value) => {
        setPlanDuration(value);
        setPlanSliderValues(plans, value, planType);
    }


    const onClose = () => {
        setPricingPopupOpen(false);
    }

    const upgrade = useMutation((price_id) => {
        return checkoutSession(price_id);
    }, {
        onSuccess: ({url}) => {
            if(url) {
                window.open(url);
            }
        }
    });


    const upgradeShopify = useMutation((price_id) => {
        return upgradeShopifySubscription(price_id);
    }, {
        onSuccess: async (data) => {
            if(data && data.confirmation_url) {
                setIsVerifyPopupOpen(false);
                setIsLoadings(true, data.confirmation_url);
            }else {
                setIsVerifyPopupOpen(false);
                toast.error('Something went wrong');
            }
           
        }
    });

    const onUpgrade = (event, customPlan) => {
        event.preventDefault();
        if(isShopify) {
            upgradeShopify.mutate(selectedSubscriber?.price_id)
        } else  if(!planDetails?.is_default) {
            if(customPlan) {
                setChosenPlan(customPlan);
            } else {
                setChosenPlan(selectedSubscriber);
            }
            setIsVerifyPopupOpen(true);
            onClose();
        } else {
            if(customPlan) {
                upgrade.mutate(customPlan?.price_id);
            } else {
                upgrade.mutate(selectedSubscriber?.price_id);
            }
        }
    }

    const chatWithUs = () => {
        setChatVisibility('maximized');
        onClose();
    }

    const isUpgradeDisabled = () => {
        if(isShopify && planDetails.status === 'cancelled') {
            return false;
        }
        if(planDetails?.website_consumed > selectedSubscriber?.website_thresholds) {
            return true;
        } 
        if(planType === 'subscriber-based') {
            if(selectedWebsite?.subscriber_count > selectedSubscriber?.subscription_thresholds) {
                return true;
            }
        } 
        if(planType === 'impression-based') {
            if(selectedWebsite?.total_impression_count > selectedSubscriber?.subscription_thresholds) {
                return true;
            }
        } 
        if(selectedSubscriber?.price_id === planDetails?.price_id) {
            return true;
        }
        return false;
    }

    return !isFetching && <><div className="modal modal-medium fade show pricing-modal" tabindex="-1">
            <div className="modal-dialog ">
            <div className="modal-content">
                <div className="modal-header justify-content-center">
                    <h2 className="modal-title text-primary text-center">Pricing</h2>
                    <button type="button" className="close" onClick={onClose} data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body full-height scrollable_y p-4">
                    <div className="toggleWrapper">
                        <input onChange={onChangePlan} type="checkbox" className="dn" id="dn" />
                        <label for="dn" className="toggle">
                            <span className="toggle__handler">
                            </span>
                        </label>
                    </div>
                    <ul className="nav nav-pills justify-content-center">
                        <li className="nav-item" onClick={() => onChangeDuration('month')} >
                            <a className={ planDuration === 'month' ?  'nav-link active' : 'nav-link'} href="#">Monthly</a>
                        </li>
                        <li className="nav-item" onClick={() => onChangeDuration('year')} >
                            <a className={ planDuration === 'year' ?  'nav-link active' : 'nav-link'} href="#">Annually</a>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div className="row cards-wrapper mt-5">
                                <div className="col-12 col-lg-6 col-xl-4">
                                    <div className="card text-center p-0 price-card">
                                        <div className="card-header">
                                            Free Plan
                                        </div>
                                        <div className="card-body">
                                            <div className="price"><sup>$</sup>0 <span>/month</span></div>
                                            <div className="small-text">Forever Free</div>
                                            <h6 className="my-2 text-primary regular">Upto {freePlanSubscribers} Subscribers</h6>
                                            <hr />
                                            <ul className="list-unstyled feature-list">
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Upto 1 Website
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Singer User
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Unlimited Notifications
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Welcome Notifications
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Detailed Analytics and Reports
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Export Reports
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Upto 3 CTA Buttons for Notifications
                                                </li>

                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Custom Tags
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 col-xl-4">
                                    <div className="card price-card active text-center p-0">
                                        <div className="card-header">
                                            Premium
                                            <h4>Most Popular</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="price"> 
                                                <sup>$</sup>{getAmount(selectedSubscriber?.amount)} 
                                                <span id="timeperd">{ planDuration === 'month' ? ' /month' : ' /year'}</span>
                                            </div>
                                            { planDuration === 'year' && <div>Save 20%</div>}
                                            <hr />
                                            <p className="my-2"><b>{wholeNumber(Number(selectedSubscriber?.subscription_thresholds))}</b> { planType === 'subscriber-based' ? 'Subscribers' : 'Impressions /month'}</p>
                                            {!isShopify && <p><b>{wholeNumber(Number(selectedSubscriber?.website_thresholds))}</b> Websites</p>
}
                                            <div className="range-colume slider-container"> 
                                                 <input type="range" 
                                                    min="0" 
                                                    max={(activePlanTypes.length * 2) - 2} 
                                                    value={subscriberCount}
                                                    className="slider" 
                                                    step={2}
                                                    onChange={({target}) => onChangeSlider(target.value) }    
                                                />
                                            </div>
                                            <div className="d-flex label-container mt-2" id="slider_container1">
                                                {
                                                    activePlanTypes.map(({subscription_thresholds}, index) => <div 
                                                        key={index}
                                                        className="label-slider"
                                                    >
                                                        {rounded(subscription_thresholds)}
                                                    </div>)
                                                }
                                            </div>
                                            <form>
                                                <input name='price_id' value={selectedSubscriber?.price_id} style={{display: 'none'}} />
                                                <input name='is_billing_address_required' value={true} style={{display: 'none'}} />
                                                <button 
                                                    type={'submit'} 
                                                    onClick={onUpgrade} 
                                                    className="btn btn-primary text-uppercase my-3"
                                                    disabled={isUpgradeDisabled()}    
                                                >
                                                    Upgrade
                                                </button>
                                                {
                                                    isUpgradeDisabled() && <div className="error-message">
                                                        {
                                                            selectedSubscriber?.price_id === planDetails?.price_id  ?  'You are already on the selected plan'
                                                            : `* ${planType === 'subscriber-based' ? 'Subscribers' : 'Impressions'}/Website limit exceeds selected plan`
                                                        }
                                                       
                                                    </div>
                                                }
                                            </form>

                                            <hr />
                                            <ul className="list-unstyled feature-list">
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Everything with Free plan and
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Multi-User Support
                                                </li>

                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Safari Browser Support
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Hide ChirpyWeb Branding
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Segmentation
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Topics
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    RSS Feed
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Drip Notifications
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Schedule Notifications (Timezone + Subscriber Timezone)
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Abandoned Cart Recovery
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Back In Stock Alerts
                                                </li>
                                                <li>
                                                    <i className="icon icon-check"></i>
                                                    Export Subscribers
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                { 
                                    !isShopify && <div className="col-12 col-lg-6 col-xl-4">
                                        <div className="card price-card text-center p-0">
                                            <div className="card-header">
                                                Enterprise  {
                                                        planDetails?.is_custom && '(Active)'
                                                    }
                                            </div>
                                            {
                                                !!customPlan ? <div className="card-body"> 
                                                    <div className="price"> 
                                                        <sup>$</sup>{getAmount(customPlan?.amount)} 
                                                        <span id="timeperd">{ customPlan?.recurring?.interval === 'month' ? ' /month' : ' /year'}</span>
                                                    </div>
                                                    <hr />
                                                    <p className="my-2"><b>{customPlan?.subscription_thresholds}</b> { customPlan?.type === 'subscriber-based' ? 'Subscribers' : 'Impressions /month'}</p>
                                                    <p><b>{customPlan?.website_thresholds}</b> Websites</p>
                                                    <button 
                                                        type={'submit'} 
                                                        onClick={(event) => onUpgrade(event, customPlan)} 
                                                        className="btn btn-primary text-uppercase my-3"
                                                        disabled={planDetails?.is_custom}    
                                                    >
                                                        Upgrade
                                                    </button>
                                                
                                                    
                                                
                                                </div>
                                                    : <div className="card-body">
                                                <p className="card-text mb-2">Contact us to discuss a custom pricing plan which
                                                    suits your needs</p>
                                                <button onClick={chatWithUs} className="btn btn-primary text-uppercase my-2">Chat with us</button>
                                            </div>
                                            }
                                            
                                        </div>
                                    </div>
                                }
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div className="modal-backdrop fade show"></div>
    </>
}

export default PricingPlans;